export default __webpack_public_path__ + "static/media/cert-ngo-hkgcsmeaa.6fe0cfcf.jpg";